"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
var currency_formatter_1 = require("currency-formatter");
var formatCurrency = function (amount, currencyCode, _a) {
    var precision = _a.precision, locale = _a.locale;
    if (locale) {
        var noNegativeZeroAmount = amount === -0 ? 0 : amount;
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currencyCode,
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
        }).format(noNegativeZeroAmount);
    }
    var formatted = (0, currency_formatter_1.format)(amount, { code: currencyCode, precision: precision });
    if (currencyCode === "CHF" && formatted.substring(formatted.length - 4) === "\xA0CHF") {
        var numberOnly = formatted.substring(0, formatted.length - 4);
        formatted = "CHF\u00A0".concat(numberOnly);
    }
    if (currencyCode === "DKK") {
        formatted = amount.toLocaleString("da-DK", { style: "currency", currency: "DKK" });
    }
    return formatted;
};
exports.formatCurrency = formatCurrency;
